export const RAISE_QUERY_ADMIN_ROLE = "RAISE_QUERY_ADMIN_ROLE";
export const RAISE_QUERY_ADMIN_ROLE_RESPONSE = "RAISE_QUERY_ADMIN_ROLE_RESPONSE";
export const RAISE_QUERY_ADMIN_ROLE_FAILED = "RAISE_QUERY_ADMIN_ROLE_FAILED";


